import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function ArrowLeftIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M11.293 4.293a1 1 0 1 1 1.414 1.414L7.414 11H19a1 1 0 1 1 0 2H7.414l5.293 5.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414z" />
    </Icon>
  );
}

ArrowLeftIcon.displayName = 'ArrowLeftIcon';
